/**
 * Surface cart stock sync results from GET /cart/items/ (stock_adjustments).
 * @param {Array<{ action?: string, title?: string, quantity?: number, available_stock?: number }>} adjustments
 * @param {(message: string) => void} notify
 */
export function notifyCartStockAdjustments(adjustments, notify) {
  if (!Array.isArray(adjustments) || !adjustments.length || typeof notify !== 'function') {
    return;
  }
  adjustments.forEach((adj) => {
    const title = (adj?.title || 'An item').trim() || 'An item';
    if (adj?.action === 'removed') {
      notify(`“${title}” was removed from your cart — it’s sold out or unavailable.`);
      return;
    }
    if (adj?.action === 'quantity_reduced') {
      const qty = adj.quantity ?? adj.available_stock;
      notify(`“${title}” quantity was updated to ${qty} (limited stock).`);
    }
  });
}
